import { connect } from 'react-redux';
import { arrayPush } from 'redux-form';
import { OCCUPANCY_BY_STORY } from '@hbrisk/sp3-risk-model-support/models/app/attributes/names/index.js';
import { modelTypesByForm } from '#src/js/constants/models/modelTypes/index.js';
import OccupancyFieldset from './OccupancyFieldset.jsx';

const mapStateToProps = (state, ownProps) => {
  const { form } = ownProps;
  const { selectFormFieldVisibility } = modelTypesByForm[form];
  return {
    defineByStory: !!selectFormFieldVisibility(state)(OCCUPANCY_BY_STORY),
  };
};

const mapDispatchToProps = (dispatch, ownProps) => {
  const { form } = ownProps;
  return {
    afterToggleOn: () => {
      dispatch(arrayPush(form, OCCUPANCY_BY_STORY, {}));
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(OccupancyFieldset);
